
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.3026',
  depVersions: {
  "customer-portal-app": "static-1.3026",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.493",
  "data-fetching-client": "static-1.9911",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26090",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5850",
  "hs-test-utils": "static-1.8280",
  "hub-http": "static-1.6468",
  "hub-http-shared-msw-handlers": "static-1.10539",
  "hubspot-dlb": "static-2.1882",
  "hubspot-prosemirror": "static-1.18886",
  "hubspot-url-utils": "static-1.4297",
  "HubStyleTokens": "static-2.11737",
  "I18n": "static-7.1664",
  "immutable": "static-2.83",
  "jasmine-runner": "static-1.6702",
  "payment-link-components": "static-1.24087",
  "portals-platform-bend-plugin": "static-1.18",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7384",
  "quartz-core": "static-1.6603",
  "quartz-i18n": "static-1.1059",
  "react": "static-7.191",
  "react-colorpicker": "static-2.10462",
  "react-dlb": "static-1.85",
  "react-utils": "static-2.5522",
  "reselect": "static-3.9",
  "rich-text-lib": "static-1.20243",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18326",
  "ui-components-test-utils": "static-1.5874",
  "UIComponents": "static-3.8683",
  "foundations-assets": "static-1.5134",
  "foundations-components": "static-1.8402",
  "foundations-theming": "static-1.4718",
  "foundations-theming-specialty": "static-1.2434",
  "framer-motion": "static-1.76",
  "metrics-js": "static-1.9867",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1363",
  "quartz-config": "static-1.1162",
  "quartz-routing": "static-1.814",
  "quick-fetch": "static-1.4100",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16966",
  "rpc-client-utils": "static-1.4917",
  "sanitize-text": "static-1-fix-mxss-decode-tags-foreign-content.3",
  "styled-components": "static-2.95",
  "tanstack-table": "static-1.59",
  "ui-addon-draggable": "static-3.5009",
  "ui-addon-react-router-dom": "static-1.9791",
  "usage-tracker": "static-1.7610",
  "usage-tracker-anonymous": "static-1.6027",
  "usage-tracker-core": "static-1.7460",
  "video-components-external": "static-1.12077",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.75",
  "redux": "static-4.76",
  "bend-plugin-trellis-migration": "static-1.3585",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3661",
  "quartz-webpack": "static-1.3608",
  "bend-plugin-quartz-routing": "static-1.462",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.86",
  "customer-data-objects": "static-1.7939",
  "frontend-preferences-client": "static-1.8181",
  "laboratory-lib": "static-3.7406",
  "onboarding-scopes": "static-1.6709",
  "seat-types-lib": "static-1.642",
  "ui-addon-opt": "static-4.8618",
  "HeadJS": "static-2.790",
  "hs-test-utils-bend-plugin": "static-1.3391",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "hs-locale-management": "static-1.261",
  "ts-schema": "static-1.4261",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8141",
  "content-media-capture": "static-1.5332",
  "cssUtils": "static-1.873",
  "customer-data-ui-utilities": "static-1.10082",
  "file-manager-components": "static-1.24377",
  "HubStyle": "static-2.12044",
  "knowledge-content-types": "static-1.8623",
  "PatternValidationJS": "static-1.3152",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.496",
  "ui-addon-emoji-picker": "static-1.10138",
  "ui-addon-i18n": "static-1.11397",
  "ui-business-units-lib": "static-1.9338",
  "ui-shepherd-react": "static-3.10518",
  "video-data-lib": "static-1.35735",
  "i18n-data": "static-1.227",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4571",
  "commerce-tours-lib": "static-1.6546",
  "customer-data-properties": "static-1.52455",
  "getting-started-shared-tasks": "static-1.19130",
  "growth-onboarding-reliability": "static-1.5335",
  "onboarding-tours": "static-1.17050",
  "reference-resolvers-lite": "static-1.8354",
  "sales-checkout-service-client": "static-1.3782",
  "ui-addon-iframeable": "static-1.9330",
  "user-context": "static-1.5368",
  "bender-build-tools": "static-1.3382",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.870",
  "hubspotter-http": "static-1.4830",
  "icons": "static-2.675",
  "mobile-manifest-mixins": "static-1.568",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.395",
  "quartz-auth": "static-1.1059",
  "quartz-head": "static-1.1049",
  "quartz-test": "static-1.1059",
  "quartz-tracking": "static-1.763",
  "trellis-components": "static-1.2515",
  "ui-fonts": "static-1.999",
  "usage-tracker-container": "static-1.7600",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9681",
  "data-token-picker": "static-1.16824",
  "FileManagerLib": "static-1.40017",
  "property-translator": "static-1.5651",
  "atom": "static-1.5340",
  "merchandise-lib": "static-1.273",
  "purchase-motions-components": "static-1.6291",
  "salesImages": "static-1.530",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5885",
  "react-create-root-preference": "static-1.63",
  "react-select-plus": "static-1.109",
  "react-virtualized": "static-2.104",
  "ui-images": "static-2.1231",
  "bend-plugin-foundations-components": "static-1.4671",
  "floating-ui": "static-1.62",
  "react-aria": "static-1.70",
  "trellis-assets": "static-1.2496",
  "bend-plugin-foundations-theming": "static-1.3201",
  "foundations-theming-base": "static-1.3703",
  "stylex": "static-1.38",
  "interframe": "static-3.5010",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6024",
  "opentelemetry-fe-types": "static-1.20",
  "web-vitals": "static-1.11",
  "bend-plugin-chirp-manifest": "static-1.327",
  "chirp-fetch": "static-1.2146",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4729",
  "react-flip-move": "static-1.75",
  "apollo-link-hub-http": "static-2.4911",
  "content-media-composition-data-lib": "static-1.13136",
  "content-media-compositions": "static-2.17143",
  "idb-keyval": "static-1.48",
  "immer": "static-1.94",
  "immerable": "static-1.4405",
  "magpie-lib": "static-1.5723",
  "magpie-types": "static-1.5183",
  "media-bridge-lib": "static-1.19346",
  "inbound-db-properties-service-client": "static-1.4025",
  "superstore": "static-1.5010",
  "feedback-loader": "static-1.29744",
  "ai-components-ui-library": "static-1.9610",
  "ui-addon-video-player": "static-1.8957",
  "ui-coaching-tips": "static-1.29230",
  "ContentUtils": "static-1.69063",
  "fix-webm-duration": "static-1.27",
  "notification-sounds": "static-1.4680",
  "sassPrefix": "static-1.161",
  "react-dnd-compat": "static-1.4870",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.1591",
  "copilot-toolkit": "static-1.11761",
  "avatar-components": "static-1.2751",
  "navigation-messaging": "static-1.8055",
  "redux-thunk": "static-2.77",
  "reference-resolvers": "static-1.8434",
  "commerce-products-lib": "static-1.10426",
  "crm-message-bus": "static-1.43660",
  "growth-data-modal": "static-1.5829",
  "hubspot-apollo-client": "static-1.5133",
  "onboarding-tours-client": "static-1.5264",
  "batch-promise": "static-1.1796",
  "calling-global-api": "static-1.65402",
  "calling-internal-common": "static-1.31572",
  "calling-lifecycle-internal": "static-1.66784",
  "calling-lifecycle-messages": "static-1.59078",
  "conditional-properties-service-client": "static-1.3982",
  "crm-index-visualization-core": "static-1.4483",
  "crm-links": "static-1.6578",
  "crm-pipelines-api-client-types": "static-1.4316",
  "customer-data-objects-ui-components": "static-1.13284",
  "customer-data-properties-shared-msw-handlers": "static-1.9866",
  "customer-data-property-utils": "static-1.8352",
  "external-options-client-types": "static-1.4307",
  "formula-editor": "static-1.14684",
  "framework-data-schema-resolvers": "static-1.7146",
  "google-libphonenumber": "static-1.42",
  "hs-resources": "static-1.445",
  "inbound-db-meta-service-client": "static-1.3718",
  "inbounddb-objects-service-types": "static-1.4392",
  "meetings-icalendar-utils-lib": "static-1.889",
  "multi-currency-client-types": "static-1.3876",
  "object-builder-ui-client": "static-1.49556",
  "pipeline-validation-client-types": "static-1.4150",
  "property-value-citations": "static-1.3069",
  "pulse": "static-1.880",
  "smart-data-capture-core": "static-1.43",
  "smart-property-lib": "static-1.8187",
  "tiered-pricing": "static-1.1883",
  "trial-components-library": "static-1.14035",
  "topics-actions-lib": "static-1.419",
  "ui-addon-form-validation": "static-1.11240",
  "zustand": "static-1.79",
  "growth-onboarding-confetti": "static-1.3315",
  "growth-onboarding-next-action-utils": "static-1.2609",
  "navigation-components": "static-1.18728",
  "onboarding-tours-utils": "static-1.1116",
  "ui-shepherd-tracker": "static-1.7899",
  "ui-universal-auth": "static-1.9306",
  "getting-started-shared-tasks-store": "static-1.18248",
  "opentelemetry-web": "static-1.11",
  "hubspotter-http-shared-msw-handlers": "static-1.10537",
  "usage-tracker-session-replay": "static-1.5296",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1220",
  "tanstack-virtual": "static-1.36",
  "audio-components": "static-1.6282",
  "FileManagerCore": "static-1.39876",
  "FileManagerImages": "static-1.37528",
  "video-components": "static-1.14079",
  "foundations-components-legacy": "static-1.1427",
  "purchase-motions-api": "static-1.6294",
  "signup-constants": "static-1.19521",
  "signup-ui-url-generator": "static-2.8314",
  "usage-tracker-public": "static-1.7421",
  "reactive-lib": "static-1.975",
  "simple-logging-lib": "static-1.3305",
  "chatspot-core": "static-1.22676",
  "growth-onboarding-feedback-components": "static-1.6839",
  "cms-field-types": "static-1.5069",
  "content-icons-ui": "static-1.2318",
  "integrations-lib": "static-1.16942",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.569",
  "breeze-engine-core": "static-1.869",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.1030",
  "customer-data-tracking": "static-1.7135",
  "products-iframe-lib": "static-1.8511",
  "products-ui-components-shared-msw-handlers": "static-1.10921",
  "restore-request-side-panel-lib": "static-1.1570",
  "onboarding-data-sync-lib": "static-1.2425",
  "hubspot-apollo-cache": "static-1.592",
  "calling-error-reporting": "static-1.31579",
  "shared-worker-versioning": "static-1.11295",
  "calling-usage-tracker": "static-1.6792",
  "voice-sms-access-library": "static-1.1926",
  "conversations-skeleton-state": "static-1.7502",
  "crm-index-associations-lib": "static-1.6697",
  "framework-data-schema-quick-fetch": "static-1.7051",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10622",
  "redux-toolkit": "static-1.75",
  "sales-views-client-types": "static-1.4511",
  "location-customization-utils-lib": "static-1.10005",
  "bark-lib": "static-1.16761",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.99",
  "crm-properties-common-lib": "static-1.6145",
  "react-codemirror": "static-1.10893",
  "fdsr-migration-layer": "static-1.265",
  "framework-builder-read-service-client": "static-1.4188",
  "persist-promise": "static-1.3953",
  "event-emitter": "static-1.1207",
  "bend-plugin-pulse": "static-1.383",
  "fast-json-patch": "static-1.67",
  "data-agent-kit": "static-1.583",
  "fsm": "static-1.3993",
  "policy-lib": "static-1.7049",
  "react-tinymce": "static-1.55892",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10685",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.55018",
  "tinymce-plugins": "static-1.58132",
  "tinymce-themes": "static-1.56988",
  "embedded-academy-lib": "static-1.15392",
  "hubs-service-types": "static-1.1513",
  "growth-onboarding-next-action-components": "static-1.2637",
  "user-context-client": "static-1.4762",
  "nest": "static-1.490",
  "unified-auth-core-lib": "static-1.1102",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.208",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.58",
  "urlinator": "static-1.4786",
  "video-embed": "static-1.36569",
  "social-insights-client-types": "static-1.22685",
  "flux-actions": "static-1.361",
  "integrations-error-boundary-lib": "static-1.14357",
  "integrations-tracking-lib": "static-1.5862",
  "native-integrations-shared-strings": "static-1.8031",
  "redux-observable": "static-1.72",
  "ReduxMessenger": "static-2.10619",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.820",
  "InboxConnectUtils": "static-4.15473",
  "meetings-connect-utils-lib": "static-1.7863",
  "calling-orchestration-schema": "static-1.36703",
  "crm-record-cards-service-types": "static-1.3759",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16281",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.108",
  "trellis-story-utils": "static-1.4764",
  "storybook-react": "static-1.37",
  "hub-http-contrib": "static-1.3293",
  "tinymce-data": "static-1.41103",
  "ui-addon-sales-email": "static-1.5468",
  "layout-dnd-components": "static-1.12900",
  "layout-dnd-utils": "static-1.11875",
  "ui-brand-identity-lib": "static-1.16249",
  "NamespacedHubStyle": "static-2.9229",
  "academy-common-lib": "static-1.14852",
  "outpost": "static-1.4414",
  "universal-page-editor-lib": "static-1.3262",
  "adobe-sign-auth-lib": "static-1.368",
  "ads-unified-auth-lib": "static-1.1105",
  "google-sheets-integration-lib": "static-1.945",
  "microsoft-drive-auth-lib": "static-1.38",
  "surveymonkey-integration-lib": "static-1.389",
  "slack-ui-library": "static-1.10652",
  "ContentData": "static-1.69138",
  "layout-data-lib": "static-1.10200",
  "academy-service-client": "static-1.3943",
  "croppie": "static-2.10",
  "final-form": "static-1.75",
  "SafeStorage": "static-1.4659",
  "trellis-ecosystem": "static-1.7569",
  "wootric-nps": "static-1.7167",
  "advanced-menus-core": "static-1.15517",
  "advanced-menus-lib": "static-1.12397",
  "ExportDialog": "static-6.10632",
  "ui-memberships-settings-lib": "static-1.34755",
  "marketplace-ui-apps-core": "static-1.19152",
  "marketplace-ui-common": "static-1.20620",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15516",
  "simple-menus-lib": "static-1.17033",
  "developer-experience-shared-components": "static-1.10755",
  "immutable-less": "static-1.4905",
  "marketplace-ui-client-types": "static-1.18027",
  "ui-addon-integrations-directory-panel": "static-2.8280",
  "ui-extensibility-client-types": "static-1.4175",
  "ai-settings-ui-library": "static-1.8264",
  "nav-meta": "static-1.30365",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.896",
  "apps-service-types": "static-1.3996",
  "oauth-service-types": "static-1.4507",
  "simple-data-table": "static-1.3450"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3026",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.493",
  "data-fetching-client": "/data-fetching-client/static-1.9911",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26090",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5850",
  "hs-test-utils": "/hs-test-utils/static-1.8280",
  "hub-http": "/hub-http/static-1.6468",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10539",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18886",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyleTokens": "/HubStyleTokens/static-2.11737",
  "I18n": "/I18n/static-7.1664",
  "immutable": "/immutable/static-2.83",
  "jasmine-runner": "/jasmine-runner/static-1.6702",
  "payment-link-components": "/payment-link-components/static-1.24087",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.18",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7384",
  "quartz-core": "/quartz-core/static-1.6603",
  "quartz-i18n": "/quartz-i18n/static-1.1059",
  "react": "/react/static-7.191",
  "react-colorpicker": "/react-colorpicker/static-2.10462",
  "react-dlb": "/react-dlb/static-1.85",
  "react-utils": "/react-utils/static-2.5522",
  "reselect": "/reselect/static-3.9",
  "rich-text-lib": "/rich-text-lib/static-1.20243",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18326",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5874",
  "UIComponents": "/UIComponents/static-3.8683",
  "foundations-assets": "/foundations-assets/static-1.5134",
  "foundations-components": "/foundations-components/static-1.8402",
  "foundations-theming": "/foundations-theming/static-1.4718",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2434",
  "framer-motion": "/framer-motion/static-1.76",
  "metrics-js": "/metrics-js/static-1.9867",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1363",
  "quartz-config": "/quartz-config/static-1.1162",
  "quartz-routing": "/quartz-routing/static-1.814",
  "quick-fetch": "/quick-fetch/static-1.4100",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16966",
  "rpc-client-utils": "/rpc-client-utils/static-1.4917",
  "sanitize-text": "/sanitize-text/static-1-fix-mxss-decode-tags-foreign-content.3",
  "styled-components": "/styled-components/static-2.95",
  "tanstack-table": "/tanstack-table/static-1.59",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5009",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9791",
  "usage-tracker": "/usage-tracker/static-1.7610",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6027",
  "usage-tracker-core": "/usage-tracker-core/static-1.7460",
  "video-components-external": "/video-components-external/static-1.12077",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.76",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3585",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3661",
  "quartz-webpack": "/quartz-webpack/static-1.3608",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.462",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.86",
  "customer-data-objects": "/customer-data-objects/static-1.7939",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8181",
  "laboratory-lib": "/laboratory-lib/static-3.7406",
  "onboarding-scopes": "/onboarding-scopes/static-1.6709",
  "seat-types-lib": "/seat-types-lib/static-1.642",
  "ui-addon-opt": "/ui-addon-opt/static-4.8618",
  "HeadJS": "/HeadJS/static-2.790",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3391",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "hs-locale-management": "/hs-locale-management/static-1.261",
  "ts-schema": "/ts-schema/static-1.4261",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8141",
  "content-media-capture": "/content-media-capture/static-1.5332",
  "cssUtils": "/cssUtils/static-1.873",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10082",
  "file-manager-components": "/file-manager-components/static-1.24377",
  "HubStyle": "/HubStyle/static-2.12044",
  "knowledge-content-types": "/knowledge-content-types/static-1.8623",
  "PatternValidationJS": "/PatternValidationJS/static-1.3152",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.496",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10138",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11397",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9338",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10518",
  "video-data-lib": "/video-data-lib/static-1.35735",
  "i18n-data": "/i18n-data/static-1.227",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4571",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6546",
  "customer-data-properties": "/customer-data-properties/static-1.52455",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19130",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5335",
  "onboarding-tours": "/onboarding-tours/static-1.17050",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8354",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3782",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9330",
  "user-context": "/user-context/static-1.5368",
  "bender-build-tools": "/bender-build-tools/static-1.3382",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.870",
  "hubspotter-http": "/hubspotter-http/static-1.4830",
  "icons": "/icons/static-2.675",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.568",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.395",
  "quartz-auth": "/quartz-auth/static-1.1059",
  "quartz-head": "/quartz-head/static-1.1049",
  "quartz-test": "/quartz-test/static-1.1059",
  "quartz-tracking": "/quartz-tracking/static-1.763",
  "trellis-components": "/trellis-components/static-1.2515",
  "ui-fonts": "/ui-fonts/static-1.999",
  "usage-tracker-container": "/usage-tracker-container/static-1.7600",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9681",
  "data-token-picker": "/data-token-picker/static-1.16824",
  "FileManagerLib": "/FileManagerLib/static-1.40017",
  "property-translator": "/property-translator/static-1.5651",
  "atom": "/atom/static-1.5340",
  "merchandise-lib": "/merchandise-lib/static-1.273",
  "purchase-motions-components": "/purchase-motions-components/static-1.6291",
  "salesImages": "/salesImages/static-1.530",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5885",
  "react-create-root-preference": "/react-create-root-preference/static-1.63",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-virtualized": "/react-virtualized/static-2.104",
  "ui-images": "/ui-images/static-2.1231",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4671",
  "floating-ui": "/floating-ui/static-1.62",
  "react-aria": "/react-aria/static-1.70",
  "trellis-assets": "/trellis-assets/static-1.2496",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3201",
  "foundations-theming-base": "/foundations-theming-base/static-1.3703",
  "stylex": "/stylex/static-1.38",
  "interframe": "/interframe/static-3.5010",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6024",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.20",
  "web-vitals": "/web-vitals/static-1.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.327",
  "chirp-fetch": "/chirp-fetch/static-1.2146",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4729",
  "react-flip-move": "/react-flip-move/static-1.75",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4911",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13136",
  "content-media-compositions": "/content-media-compositions/static-2.17143",
  "idb-keyval": "/idb-keyval/static-1.48",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4405",
  "magpie-lib": "/magpie-lib/static-1.5723",
  "magpie-types": "/magpie-types/static-1.5183",
  "media-bridge-lib": "/media-bridge-lib/static-1.19346",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4025",
  "superstore": "/superstore/static-1.5010",
  "feedback-loader": "/feedback-loader/static-1.29744",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9610",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8957",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29230",
  "ContentUtils": "/ContentUtils/static-1.69063",
  "fix-webm-duration": "/fix-webm-duration/static-1.27",
  "notification-sounds": "/notification-sounds/static-1.4680",
  "sassPrefix": "/sassPrefix/static-1.161",
  "react-dnd-compat": "/react-dnd-compat/static-1.4870",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1591",
  "copilot-toolkit": "/copilot-toolkit/static-1.11761",
  "avatar-components": "/avatar-components/static-1.2751",
  "navigation-messaging": "/navigation-messaging/static-1.8055",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reference-resolvers": "/reference-resolvers/static-1.8434",
  "commerce-products-lib": "/commerce-products-lib/static-1.10426",
  "crm-message-bus": "/crm-message-bus/static-1.43660",
  "growth-data-modal": "/growth-data-modal/static-1.5829",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5133",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5264",
  "batch-promise": "/batch-promise/static-1.1796",
  "calling-global-api": "/calling-global-api/static-1.65402",
  "calling-internal-common": "/calling-internal-common/static-1.31572",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66784",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59078",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3982",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4483",
  "crm-links": "/crm-links/static-1.6578",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4316",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13284",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9866",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8352",
  "external-options-client-types": "/external-options-client-types/static-1.4307",
  "formula-editor": "/formula-editor/static-1.14684",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7146",
  "google-libphonenumber": "/google-libphonenumber/static-1.42",
  "hs-resources": "/hs-resources/static-1.445",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4392",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.889",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3876",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49556",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4150",
  "property-value-citations": "/property-value-citations/static-1.3069",
  "pulse": "/pulse/static-1.880",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.43",
  "smart-property-lib": "/smart-property-lib/static-1.8187",
  "tiered-pricing": "/tiered-pricing/static-1.1883",
  "trial-components-library": "/trial-components-library/static-1.14035",
  "topics-actions-lib": "/topics-actions-lib/static-1.419",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11240",
  "zustand": "/zustand/static-1.79",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3315",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2609",
  "navigation-components": "/navigation-components/static-1.18728",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1116",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7899",
  "ui-universal-auth": "/ui-universal-auth/static-1.9306",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18248",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10537",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5296",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1220",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "audio-components": "/audio-components/static-1.6282",
  "FileManagerCore": "/FileManagerCore/static-1.39876",
  "FileManagerImages": "/FileManagerImages/static-1.37528",
  "video-components": "/video-components/static-1.14079",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1427",
  "purchase-motions-api": "/purchase-motions-api/static-1.6294",
  "signup-constants": "/signup-constants/static-1.19521",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8314",
  "usage-tracker-public": "/usage-tracker-public/static-1.7421",
  "reactive-lib": "/reactive-lib/static-1.975",
  "simple-logging-lib": "/simple-logging-lib/static-1.3305",
  "chatspot-core": "/chatspot-core/static-1.22676",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6839",
  "cms-field-types": "/cms-field-types/static-1.5069",
  "content-icons-ui": "/content-icons-ui/static-1.2318",
  "integrations-lib": "/integrations-lib/static-1.16942",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.569",
  "breeze-engine-core": "/breeze-engine-core/static-1.869",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.1030",
  "customer-data-tracking": "/customer-data-tracking/static-1.7135",
  "products-iframe-lib": "/products-iframe-lib/static-1.8511",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10921",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1570",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2425",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.592",
  "calling-error-reporting": "/calling-error-reporting/static-1.31579",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11295",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6792",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1926",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7502",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6697",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7051",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10622",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "sales-views-client-types": "/sales-views-client-types/static-1.4511",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10005",
  "bark-lib": "/bark-lib/static-1.16761",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.99",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6145",
  "react-codemirror": "/react-codemirror/static-1.10893",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.265",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4188",
  "persist-promise": "/persist-promise/static-1.3953",
  "event-emitter": "/event-emitter/static-1.1207",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.383",
  "fast-json-patch": "/fast-json-patch/static-1.67",
  "data-agent-kit": "/data-agent-kit/static-1.583",
  "fsm": "/fsm/static-1.3993",
  "policy-lib": "/policy-lib/static-1.7049",
  "react-tinymce": "/react-tinymce/static-1.55892",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10685",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.55018",
  "tinymce-plugins": "/tinymce-plugins/static-1.58132",
  "tinymce-themes": "/tinymce-themes/static-1.56988",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15392",
  "hubs-service-types": "/hubs-service-types/static-1.1513",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2637",
  "user-context-client": "/user-context-client/static-1.4762",
  "nest": "/nest/static-1.490",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1102",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.208",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.58",
  "urlinator": "/urlinator/static-1.4786",
  "video-embed": "/video-embed/static-1.36569",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "flux-actions": "/flux-actions/static-1.361",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14357",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5862",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8031",
  "redux-observable": "/redux-observable/static-1.72",
  "ReduxMessenger": "/ReduxMessenger/static-2.10619",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.820",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15473",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7863",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36703",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3759",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16281",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.108",
  "trellis-story-utils": "/trellis-story-utils/static-1.4764",
  "storybook-react": "/storybook-react/static-1.37",
  "hub-http-contrib": "/hub-http-contrib/static-1.3293",
  "tinymce-data": "/tinymce-data/static-1.41103",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5468",
  "layout-dnd-components": "/layout-dnd-components/static-1.12900",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11875",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16249",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9229",
  "academy-common-lib": "/academy-common-lib/static-1.14852",
  "outpost": "/outpost/static-1.4414",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3262",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.368",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1105",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.945",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.38",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.389",
  "slack-ui-library": "/slack-ui-library/static-1.10652",
  "ContentData": "/ContentData/static-1.69138",
  "layout-data-lib": "/layout-data-lib/static-1.10200",
  "academy-service-client": "/academy-service-client/static-1.3943",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.75",
  "SafeStorage": "/SafeStorage/static-1.4659",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7569",
  "wootric-nps": "/wootric-nps/static-1.7167",
  "advanced-menus-core": "/advanced-menus-core/static-1.15517",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12397",
  "ExportDialog": "/ExportDialog/static-6.10632",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34755",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19152",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20620",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15516",
  "simple-menus-lib": "/simple-menus-lib/static-1.17033",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10755",
  "immutable-less": "/immutable-less/static-1.4905",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18027",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8280",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4175",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8264",
  "nav-meta": "/nav-meta/static-1.30365",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.896",
  "apps-service-types": "/apps-service-types/static-1.3996",
  "oauth-service-types": "/oauth-service-types/static-1.4507",
  "simple-data-table": "/simple-data-table/static-1.3450"
}
};
